import script from "./FloatingBubble.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatingBubble.vue?vue&type=script&setup=true&lang=js"

import "./FloatingBubble.vue?vue&type=style&index=0&id=7e7415e6&lang=less&scoped=true"

import exportComponent from "/usr/share/nginx/html/vue_saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e7415e6"]])

export default __exports__